export default __webpack_public_path__ + "static/media/ivanv_m.e8c022a0.jpg";